.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: var(--space-4);
  margin-bottom: var(--space-6);
}

.grid {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
  gap: var(--space-5);
  align-items: start;
}

.chartBody {
  padding: var(--space-4) var(--space-4) var(--space-3);
}

.recent {
  display: flex;
  flex-direction: column;
}

.recentItem {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-5);
  border-bottom: 1px solid var(--border-subtle);
  width: 100%;
  text-align: left;
  transition: background var(--duration-fast) var(--ease-out);
}

.recentItem:last-child {
  border-bottom: none;
}

.recentItem:hover {
  background: var(--bg-hover);
}

.recentBody {
  flex: 1;
  min-width: 0;
}

.recentTitle {
  font-weight: var(--weight-medium);
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recentMeta {
  margin-top: 2px;
  font-size: var(--text-xs);
  color: var(--text-tertiary);
}

.recentValue {
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  color: var(--text-secondary);
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}

.modeList {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.modeRow {
  display: grid;
  grid-template-columns: minmax(84px, auto) 1fr auto;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--text-sm);
}

.modeName {
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modeBarTrack {
  /* A <span> is inline by default, which gives its child a 0 height. */
  display: block;
  height: 8px;
  border-radius: var(--radius-pill);
  background: var(--bg-inset);
  overflow: hidden;
}

.modeBar {
  display: block;
  height: 100%;
  border-radius: var(--radius-pill);
  background: var(--viz-1);
}

.modeCount {
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
  font-weight: var(--weight-medium);
}

.footerLink {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-3);
  border-top: 1px solid var(--border-subtle);
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.footerLink:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
  text-decoration: none;
}

@media (max-width: 1080px) {
  .grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* A grid cell that stacks several cards. */
.column {
  display: grid;
  gap: var(--space-5);
  align-content: start;
  min-width: 0;
}
